import { render, staticRenderFns } from "./Cemetary.vue?vue&type=template&id=55953555"
import script from "./Cemetary.vue?vue&type=script&lang=js"
export * from "./Cemetary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports